<template>
  <div>
    <el-form
      :inline="true"
      :model="queryInfo"
      class="form"
      style="margin-bottom: -10px"
    >
      <el-form-item label="电站名称：">
        <el-input
          placeholder="请输入电站名称"
          clearable
          v-model="queryInfo.name"
          @change="getPowerStationList"
          @clear="getPowerStationList"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="联系人：">
        <el-input
          placeholder="请输入联系人"
          @change="getPowerStationList"
          clearable
          v-model="queryInfo.contacts"
          @clear="getPowerStationList"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="场站模式：">
        <el-select v-model="moshi" placeholder="请选择场站模式" filterable>
          <el-option
            v-for="(item, index) in stationModeList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否分账：">
        <el-select v-model="fenzhang" placeholder="请选择是否分账" filterable>
          <el-option
            v-for="(item, index) in orSasList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电站状态" filterable>
        <el-select
          v-model="zhuangtai"
          placeholder="请选择电站状态"
          style="width: 100%"
          filterable
        >
          <el-option
            v-for="item in stationStatelist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="chaxun"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-refresh-left" @click="chongzhi"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 地图选点对话框 -->
    <el-dialog
      title="选择位置"
      :visible.sync="mapDialogVisible"
      width="70%"
      class="dialogStyle"
      @close="qx4"
      append-to-body
      :close-on-click-modal="false"
    >
      <div id="myPageTop">
        <el-input
          id="tipinput"
          style="width: 300px"
          placeholder="输入提示后查询"
          v-model="keyword"
        >
          <el-button
            type="primary"
            slot="append"
            icon="el-icon-search"
            @click="searchKeyWord"
          ></el-button>
        </el-input>
      </div>
      <div id="container"></div>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="qx4">取 消</el-button>
        <el-button type="primary" @click="editMapPosition">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加&编辑电站的对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="powerStationVisible"
      @close="powerStationDialogClosed"
      append-to-body
      :close-on-click-modal="false"
    >
      <!-- 内容主体区域 -->
      <el-form :model="stationInfo" ref="powerStationRef" label-width="100px">
        <el-form-item
          label="电站类别"
          prop="stationMode"
          v-if="title === '添加电站'"
        >
          <el-radio-group
            v-model="stationInfo.stationMode"
            @change="radioelerc_change"
          >
            <el-radio
              v-for="(item, index) in radioeletric"
              :key="index"
              :label="item.id"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电站名称" prop="stationName">
          <el-input
            v-model="stationInfo.stationName"
            placeholder="请输入电站名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="电站地址" prop="address">
          <el-input
            v-model="stationInfo.address"
            placeholder="请输入电站地址"
          ></el-input>
          <el-button style="margin-top: 5px" size="small" @click="getMap"
            >获取地图位置</el-button
          >
        </el-form-item>
        <el-form-item label="电站类型" prop="stationType">
          <el-select
            v-model="stationInfo.stationType"
            placeholder="请选择电站类型"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in stationTypeData"
              :key="item"
              :label="
                item == 1
                  ? '公共设备'
                  : item == 50
                  ? '个人专用'
                  : item == 104
                  ? '内部专用'
                  : item == 100
                  ? '公交专用'
                  : item == 101
                  ? '环卫专用'
                  : item == 102
                  ? '物流专用'
                  : item == 103
                  ? '出租车专用'
                  : item == 255
                  ? '其他'
                  : ''
              "
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对外显示" prop="stationDisplay">
          <el-switch
            v-model="stationInfo.stationDisplay"
            active-value="0"
            inactive-value="1"
            active-color="#ff4949"
            inactive-color="#13ce66"
          ></el-switch>
          <span style="color: red; margin-left: 20px">(仅锐创合作小程序)</span>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input
                disabled
                v-model="stationInfo.longitude"
                placeholder="请通过地图获取经度"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input
                v-model="stationInfo.contacts"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
            <el-form-item label="电站总功率" prop="totalPower">
              <el-input
                v-model="stationInfo.totalPower"
                placeholder="请输入电站总功率"
                style="width: 70%"
              ></el-input>
              （kWh）
            </el-form-item>
            <el-form-item label="离线充电" prop="brokenNet">
              <el-switch
                v-model="stationInfo.brokenNet"
                active-value="0"
                inactive-value="1"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
              <span style="color: red; margin-left: 20px"
                >(仅支持直流充电桩)</span
              >
            </el-form-item>

            <el-form-item label="电站状态" prop="stationState">
              <el-select
                v-model="stationInfo.stationState"
                placeholder="请选择电站状态"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in stateData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="卡状态" prop="field">
              <el-select
                v-model="stationInfo.icState"
                placeholder="请选择电卡状态"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in cardType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input
                disabled
                v-model="stationInfo.latitude"
                placeholder="请通过地图获取纬度"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="contactsTel">
              <el-input
                v-model="stationInfo.contactsTel"
                placeholder="请输入电话号码"
              ></el-input>
            </el-form-item>
            <el-form-item label="组织代码" prop="hlhtEquipmentOwnerId">
              <el-input
                v-model="stationInfo.hlhtEquipmentOwnerId"
                placeholder="请输入组织代码"
              ></el-input>
            </el-form-item>
            <el-form-item label="离线充电量" prop="brokenNetCharging">
              <el-input-number
                v-model="stationInfo.brokenNetCharging"
                controls-position="right"
                :clearable="true"
                :min="0"
                style="width: 70%"
              ></el-input-number>
              （kWh）
            </el-form-item>
            <el-form-item label="他站费率显示" prop="feeModelDisplay">
              <el-switch
                v-model="stationInfo.feeModelDisplay"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
            <el-form-item label="营业时间" prop="field">
              <el-input
                placeholder="请输入场地信息"
                v-model="stationInfo.field"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="二维码" prop="parking">
              <el-radio-group v-model="stationInfo.qrCodeType">
                <el-radio
                  v-for="(item, index) in radioMSK"
                  :key="index"
                  :label="item.qrCodeType"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开票" prop="isInvoice">
              <el-radio-group v-model="stationInfo.isInvoice" style="flex: 1">
                <el-radio
                  v-for="(item, index) in radioisInvoice"
                  :key="index"
                  :label="item.isInvoice"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="消费类型" prop="consumptionType">
              <el-select
                v-model="stationInfo.consumptionType"
                placeholder="请选择电站类型"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in consumptionTypepeData"
                  :key="item"
                  :label="
                    item == 0
                      ? '全部允许'
                      : item == 1
                      ? '仅绑定金额'
                      : item == 2
                      ? '仅即充即退'
                      : item == 3
                      ? '仅刷卡'
                      : item == 4
                      ? '默认个人账户'
                      : item == 5
                      ? '默认即充即退'
                      : '默认绑定金额'
                  "
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="停车类型" prop="parkType">
              <el-radio-group
                v-model="stationInfo.parkType"
                @change="parkType_change"
                style="flex: 1"
              >
                <el-radio
                  v-for="(item, index) in radioparkType"
                  :key="index"
                  :label="item.parkType"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12" v-if="stationInfo.parkType == 3">
            <el-form-item label="停车厂商" prop="parkModelId">
              <el-select
                v-model="stationInfo.parkModelId"
                placeholder="请选择停车厂商"
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in carTypeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="stationInfo.parkType == 3">
            <el-form-item label="车场编号" prop="outMcNo">
              <el-input
                v-model="stationInfo.outMcNo"
                placeholder="请输入车场编号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="stationInfo.parkType == 3">
          <el-col :span="12">
            <el-form-item label="减免方式" prop="derateType">
              <el-select
                v-model="stationInfo.derateType"
                placeholder="请选择减免方式"
                filterable
                style="width: 100%"
                @change="jianmian"
              >
                <el-option
                  v-for="item in derateTypeData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="stationInfo.derateType > 0">
            <el-form-item label="减免内容" prop="derateValue">
              <el-input
                v-model="stationInfo.derateValue"
                :placeholder="
                  stationInfo.derateType == 1
                    ? '减免金额 （单位分）'
                    : stationInfo.derateType == 2
                    ? '减免时长（单位分钟）'
                    : '折扣（10代表1折 98代表98折）'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="是否分账" prop="parking">
          <el-radio-group v-model="stationInfo.orSas" style="flex: 1">
            <el-radio
              v-for="(item, index) in radioMoney"
              :key="index"
              :label="item.orSas"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="停车信息" prop="parking">
          <el-input
            placeholder="请输入停车信息"
            v-model="stationInfo.parking"
          ></el-input>
        </el-form-item>
        <el-form-item label="本站通知">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="changeTimeall"
          >
          </el-date-picker>
          <el-input
            placeholder="请输入本站通知"
            v-model="stationInfo.notice"
            style="margin-top: 20px"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部按钮区域 -->
      <p slot="footer" class="dialog-footer">
        <el-button @click="powerStationDialogClosed">取 消</el-button>
        <el-button type="primary" v-debounce="editPowerStation"
          >确 定</el-button
        >
      </p>
    </el-dialog>
    <!-- 上传图片对话框 -->
    <el-dialog
      title="上传图片"
      :visible.sync="imgVisible"
      width="30%"
      @close="img_close"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo"
        action="/api0/station-info/upLoadStationPicture"
        :on-change="handleChange"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary"
          >点击上传场站默认图片（单）</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="ok"
          >确定上传图片（单）</el-button
        >
      </el-upload>
      <input
        v-if="imgg != null"
        type="image"
        :src="imgg"
        alt=""
        style="
          margin-top: 20px;
          margin-bottom: 20px;
          width: 100px;
          height: 100px;
        "
      />
      <el-upload
        class="upload-demo"
        action="/api0/station-info/upLoadStationPictures"
        :file-list="newfilelist"
        :on-change="beforeChange"
        :auto-upload="false"
        list-type="picture"
        style="margin-top: 40px"
      >
        <el-button slot="trigger" size="small" type="primary"
          >点击上传场站轮播图（多）</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          v-debounce="ok_succ"
          >确定上传图片（多）</el-button
        >
      </el-upload>
      <li v-if="imgges != null" style="list-style: none">
        <img
          :src="tupian + item"
          alt=""
          v-for="(item, index) in imgges"
          :key="index"
          style="width: 100px; height: 100px; margin: 20px"
        />
      </li>
    </el-dialog>
    <!-- 停车策略 -->
    <el-dialog
      :title="carInfo.parkModelId == 0 ? '费率设置' : '费率编辑'"
      :visible.sync="editDialogVisible2"
      style="width: 50%; margin-left: 25%; list-style: none"
      @close="btn_click2"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="center">
        <el-form :model="carInfo" ref="editFormRef" label-position="left">
          <!-- <el-row :gutter="20">
          <el-form-item label="费率类型：" style="margin-left: 20px;">
            <el-radio-group v-model="feeModelType">
              <el-radio v-for="(item, index) in testArray" :key="index" :label="item.id">
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row> -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="免费时长：">
                <input
                  v-model="carInfo.fixServiceFee"
                  type="number"
                  :min="0"
              :max="6.5000"
              :step="0.0001"
                  class="money1"
                  style="width: 80px"
                />(分钟)
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="停车费率：">
                <input
                  v-model="carInfo.fixFee"
                  type="number"
                  :min="0.0"
                  :max="6.5"
                  :step="0.0001"
                  class="money1"
                  style="width: 80px"
                />(元/分钟)
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="满足电量：">
                <input
                  v-model="carInfo.billingPolicy"
                  type="number"
                  :min="0.0"
                  :max="6.5"
                  :step="0.0001"
                  class="money1"
                  style="width: 80px"
                />(度)
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="封顶金额：">
                <input
                  v-model="carInfo.timeFeeModel"
                  type="number"
                  :min="0.0"
                  :step="0.0001"
                  class="money1"
                  style="width: 80px"
                />(元)
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
          style="
            display: flex;
            justify-content: flex-end;
            margin-right: 5%;
            margin-top: 30px;
          "
        >
          <el-button @click="btn_click2">取 消</el-button>
          <el-button type="primary" v-debounce="editTariff2">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 交直流策略 -->
    <el-dialog
      :title="MoneyInfo1.feeModelId == 0 ? '费率设置' : '费率编辑'"
      :visible.sync="celvDialog1"
      style="width: 100%; height: 100%"
      @close="btn_click1"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :model="MoneyInfo1"
        ref="editFormRef"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="费率类型：">
          <el-radio-group v-model="MoneyInfo1.feeModelType">
            <el-radio
              v-for="(item, index) in radioArray1"
              :key="index"
              :label="item.id"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="费用配置:" v-if="MoneyInfo1.feeModelType == 0">
          <el-row
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-around;
              margin-top: -40px;
            "
          >
            <el-col style="width: 300px; margin-right: 20px">
              <template>
                <p style="display: flex; justify-content: center">
                  电费（元/度）
                </p>
                <el-input-number
                  placeholder="请输入电费"
                  style="width: 90%"
                  v-model="MoneyInfo1.fixFee"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  :precision="4"
                  @input="handleInput"
                >
                </el-input-number>
              </template>
            </el-col>
            <el-col style="width: 300px">
              <template>
                <p style="display: flex; justify-content: center">
                  服务费（元/度）
                </p>
                <el-input-number
                  placeholder="请输入服务费"
                  style="width: 90%"
                  v-model="MoneyInfo1.fixServiceFee"
                  :min="0"
              :max="6.5000"
              :step="0.0001"
                  :precision="4"
                  @input="handleInput"
                >
                </el-input-number>
              </template>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="MoneyInfo1.feeModelType == 1">
          <el-row>
            <el-col
              style="
                width: 420px;
                margin-top: -20px;
                display: flex;
                flex-direction: row;
                margin-left: -8%;
              "
            >
              <span
                style="margin-right: 10px; margin-bottom: -5px; width: 250px"
                >全时服务费（元/度）</span
              >
              <el-input-number
                v-model="MoneyInfo1.fixServiceFee"
                :min="0"
              :max="6.5000"
              :step="0.0001"
                style="width: 100%"
                placeholder="请输入服务费"
                placeholder-style="font-size:28rpx;color:#999999;"
                :precision="4"
                @input="handleInput"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item
          label="费用配置:"
          v-if="MoneyInfo1.feeModelType == 1"
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-top: -20px;
          "
        >
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
            placeholder-style="font-size:28rpx;color:#999999"
          >
            <el-col style="width: 300px; margin-right: 5%; margin-top: -20px">
              <template>
                <p style="margin-left: 50%">名称</p>
                <el-input
                  placeholder="尖时"
                  :disabled="true"
                  style="width: 100%"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%; margin-top: -20px"
              ><template>
                <p style="display: flex; justify-content: center">
                  电费（元/度）
                </p>
                <el-input-number
                  v-model="MoneyInfo1.tip"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  style="width: 100%"
                  placeholder="请输入电费"
                  :precision="4"
                  @input="handleInput"
                >
                </el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input
                  placeholder="峰时"
                  style="width: 100%"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  v-model="MoneyInfo1.peak"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  style="width: 100%"
                  placeholder="请输入电费"
                  :precision="4"
                  @input="handleInput"
                >
                </el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input
                  style="width: 100%"
                  placeholder="平时"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col
              style="
                width: 300px;
                display: flex;
                flex-direction: column;
                margin-right: 5%;
              "
              ><template>
                <el-input-number
                  v-model="MoneyInfo1.flat"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  style="width: 100%"
                  placeholder="请输入电费"
                  @input="handleInput"
                  :precision="4"
                >
                </el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%"
              ><template>
                <el-input
                  style="width: 100%"
                  placeholder="谷时"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%"
              ><template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.valley"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入电费"
                  @input="handleInput"
                  :precision="4"
                >
                </el-input-number>
              </template>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item v-if="MoneyInfo1.feeModelType == 2">
          <p
            style="
              color: red;
              margin-top: -20px;
              padding-bottom: 10px;
              margin-left: -8%;
            "
          >
            * 注：此处仅设置无疆交流桩固定服务费，无疆交流桩暂不支持分时服务费。
          </p>
          <el-row>
            <el-col
              style="
                width: 420px;
                margin-top: -20px;
                display: flex;
                flex-direction: row;
                margin-left: -8%;
              "
            >
              <span
                style="margin-top: -10px; margin-bottom: -5px; width: 250px"
              >
                全时服务费（元/度）</span
              >
              <el-input-number
                style="width: 80%"
                v-model="MoneyInfo1.fixServiceFee"
                :min="0"
              :max="6.5000"
              :step="0.0001"
                placeholder="请输入服务费"
                @input="handleInput"
                :precision="4"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          label="费用配置"
          v-if="MoneyInfo1.feeModelType == 2"
          style="width: 100%; margin-top: 20px"
        >
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-evenly;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%; margin-top: 20px">
              <template>
                <p style="display: flex; justify-content: center">名称</p>
                <el-input
                  style="width: 100%"
                  placeholder="尖时"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%; margin-top: 20px">
              <template>
                <p style="display: flex; justify-content: center">
                  电费（元/度）
                </p>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.tip"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入电费"
                  @input="handleInput"
                  :precision="4"
                >
                </el-input-number>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%; margin-top: 20px">
              <template>
                <p style="display: flex; justify-content: center">
                  服务费（元/度）
                </p>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.tipService"
                  :min="0"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入服务费"
                  @input="handleInput"
                  :precision="4"
                >
                </el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-evenly;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input
                  style="width: 100%"
                  placeholder="峰时"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.peak"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入电费"
                  @input="handleInput"
                  :precision="4"
                ></el-input-number>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.peakService"
                  :min="0"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入服务费"
                  @input="handleInput"
                  :precision="4"
                ></el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-evenly;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input
                  style="width: 100%"
                  placeholder="平时"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.flat"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入电费"
                  @input="handleInput"
                  :precision="4"
                ></el-input-number>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.flatService"
                  :min="0"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入服务费"
                  @input="handleInput"
                  :precision="4"
                ></el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
          <el-row
            style="
              flex: 1;
              display: flex;
              margin-top: -20px;
              flex-direction: row;
              justify-content: space-evenly;
              align-items: center;
            "
          >
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input
                  style="width: 100%"
                  placeholder="谷时"
                  :disabled="true"
                ></el-input>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.valley"
                  :min="0.0001"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入电费"
                  @input="handleInput"
                  :precision="4"
                ></el-input-number>
              </template>
            </el-col>
            <el-col style="width: 300px; margin-right: 5%">
              <template>
                <el-input-number
                  style="width: 100%"
                  v-model="MoneyInfo1.valleyService"
                  :min="0"
                  :max="6.5"
                  :step="0.0001"
                  placeholder="请输入服务费"
                  @input="handleInput"
                  :precision="4"
                ></el-input-number>
              </template>
            </el-col>
          </el-row>
          <br />
        </el-form-item>
        <el-form-item label="费用配置:" v-if="MoneyInfo1.feeModelType !== 0">
          <div>
            <div v-for="(item, index) in timeList1" :key="index">
              <el-select v-model="item.type">
                <el-option
                  v-for="item2 in options2"
                  :key="item2"
                  :value="item2"
                ></el-option>
              </el-select>
              <el-select
                v-model="item.start"
                style="width: 20%; margin-left: 10px"
              >
                <el-option
                  v-for="(timeItem, timeIndex) in timeListAll"
                  :key="timeIndex"
                  :label="timeItem"
                  :value="timeItem"
                  :disabled="getBeginSelect(timeIndex)"
                />
              </el-select>
              <span style="padding: 0 10px">-</span>
              <el-select
                v-model="item.end"
                style="width: 20%"
                :disabled="!timeList1[index].start"
              >
                <el-option
                  v-for="(timeItem, timeIndex) in timeListAll"
                  :key="timeIndex"
                  :label="timeItem"
                  :value="timeItem"
                  :disabled="getEndSelect(timeItem, timeIndex, index)"
                />
              </el-select>
              <el-button
                style="margin-left: 10px"
                type="danger"
                @click="delMethods(index)"
                icon="el-icon-delete"
                >删除</el-button
              >
            </div>
            <el-button
              type="primary"
              @click="addNewRange"
              :disabled="canAddNew()"
              >新增时间段</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="
          display: flex;
          justify-content: flex-end;
          margin-right: 5%;
          margin-top: 30px;
        "
      >
        <el-button @click="btn_click1">取 消</el-button>
        <el-button type="primary" v-debounce="editTariffs1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 低速策略 -->
    <el-dialog
      :title="MoneyInfo2.feeModelId == 0 ? '费率设置' : '费率编辑'"
      :visible.sync="celvDialog2"
      style="width: 100%; height: 100%"
      @close="btn_click3"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="center">
        <el-form
          :model="MoneyInfo2"
          ref="editFormRef"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="费率类型：">
            <el-radio-group
              v-model="MoneyInfo2.feeModelType"
              @change="tariffChange2"
            >
              <el-radio
                v-for="(item, index) in radioArray2"
                :key="index"
                :label="item.id"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="费用配置:" v-if="MoneyInfo2.feeModelType == 0">
            <el-row
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                margin-top: -40px;
              "
            >
              <el-col style="width: 300px; margin-right: 20px">
                <template>
                  <p
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 20px;
                      margin-bottom: -20px;
                    "
                  >
                    电费（元/度）
                  </p>
                  <el-input-number
                    placeholder="请输入电费"
                    style="width: 90%; margin-top: 20px"
                    v-model="MoneyInfo2.fixFee"
                    :min="0.0001"
                    :max="6.5"
                    :step="0.0001"
                    :precision="3"
                    @input="handleInput2"
                  >
                  </el-input-number>
                </template>
              </el-col>
              <el-col style="width: 300px">
                <template>
                  <p
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 20px;
                      margin-bottom: -20px;
                    "
                  >
                    服务费（元/度）
                  </p>
                  <el-input-number
                    placeholder="请输入服务费"
                    style="width: 90%; margin-top: 20px"
                    v-model="MoneyInfo2.fixServiceFee"
                    :min="0"
              :max="6.5000"
              :step="0.0001"
                    :precision="3" @input="handleInput2"
                  >
                  </el-input-number>
                </template>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="固定费率："
            v-if="MoneyInfo2.feeModelType == 3 || MoneyInfo2.feeModelType == 4"
          >
            <span style="margin-right: 20px">电费</span
            ><input
              v-model="MoneyInfo2.fixFee"
              type="number"
              :min="0.0001"
              :max="6.5"
              :step="0.0001"
              style="
                width: 10%;
                text-align: center;
                height: 20px;
                border: 1px solid #ccc;
              " @input="handleInput2"
              class="money1"
            />（元/小时） <span style="margin: 0 20px">服务费</span
            ><input
              v-model="MoneyInfo2.fixServiceFee"
              type="number"
              :min="0"
              :max="6.5000"
              :step="0.0001"
              style="
                width: 10%;
                text-align: center;
                height: 20px;
                border: 1px solid #ccc;
              " @input="handleInput2"
              class="money1"
            />（元/小时）
          </el-form-item>
          <el-form-item label="时段费率：" v-if="MoneyInfo2.feeModelType == 2">
            <el-row
              style="
                flex: 1;
                display: flex;
                margin-top: -20px;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;
              "
            >
              <el-col style="width: 300px; margin-right: 5%; margin-top: -20px">
                <template>
                  <p style="display: flex; justify-content: center">名称</p>
                  <el-input
                    style="width: 100%"
                    placeholder="尖时"
                    :disabled="true"
                  ></el-input>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%; margin-top: -20px">
                <template>
                  <p style="display: flex; justify-content: center">
                    电费（元/度）
                  </p>
                  <el-input-number
                    style="width: 100%"
                    :min="0.0001"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入电费"
                    v-model="billingPolicy2.tip"
                    :precision="3" @input="handleInput2"
                  >
                  </el-input-number>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%; margin-top: -20px">
                <template>
                  <p style="display: flex; justify-content: center">
                    服务费（元/度）
                  </p>
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入服务费"
                    v-model="billingPolicy2.tipService"
                    :precision="3" @input="handleInput2"
                  >
                  </el-input-number>
                </template>
              </el-col>
            </el-row>
            <br />
            <el-row
              style="
                flex: 1;
                display: flex;
                margin-top: -20px;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;
              "
            >
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input
                    style="width: 100%"
                    placeholder="峰时"
                    :disabled="true"
                  ></el-input>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input-number
                    style="width: 100%"
                    :min="0.0001"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入电费"
                    v-model="billingPolicy2.peak"
                    :precision="3" @input="handleInput2"
                  ></el-input-number>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入服务费"
                    v-model="billingPolicy2.peakService"
                    :precision="3" @input="handleInput2"
                  ></el-input-number>
                </template>
              </el-col>
            </el-row>
            <br />
            <el-row
              style="
                flex: 1;
                display: flex;
                margin-top: -20px;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;
              "
            >
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input
                    style="width: 100%"
                    placeholder="平时"
                    :disabled="true"
                  ></el-input>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input-number
                    style="width: 100%"
                    :min="0.0001"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入电费"
                    v-model="billingPolicy2.flat"
                    :precision="3" @input="handleInput2"
                  ></el-input-number>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入服务费"
                    v-model="billingPolicy2.flatService"
                    :precision="3" @input="handleInput2"
                  ></el-input-number>
                </template>
              </el-col>
            </el-row>
            <br />
            <el-row
              style="
                flex: 1;
                display: flex;
                margin-top: -20px;
                flex-direction: row;
                justify-content: space-evenly;
                align-items: center;
              "
            >
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input
                    style="width: 100%"
                    placeholder="谷时"
                    :disabled="true"
                  ></el-input>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input-number
                    style="width: 100%"
                    :min="0.0001"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入电费"
                    v-model="billingPolicy2.valley"
                    :precision="3" @input="handleInput2"
                  ></el-input-number>
                </template>
              </el-col>
              <el-col style="width: 300px; margin-right: 5%">
                <template>
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    :max="6.5"
                    :step="0.0001"
                    placeholder="请输入服务费"
                    v-model="billingPolicy2.valleyService"
                    :precision="3" @input="handleInput2"
                  ></el-input-number>
                </template>
              </el-col>
            </el-row>
            <br />
          </el-form-item>
          <el-divider
            v-if="MoneyInfo2.feeModelType == 4"
            content-position="center"
            >每档位收费功率区间</el-divider
          >
          <el-form-item v-if="MoneyInfo2.feeModelType == 4">
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;
                margin-left: -40px;
              "
            >
              <li
                v-for="(items, indexs) in shuzu"
                :key="indexs"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                "
              >
                <span>{{ indexs + 1 + '、' }}</span>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    border: 1px solid #dcdfe6;
                    font-size: 12px;
                    margin: 0 20px 20px 0;
                    width: 360px;
                  "
                >
                  <el-input-number
                    v-model="items.name"
                    @change="input_event1(indexs)"
                    :min="0"
                    :max="4000"
                    style="margin-right: 10px"
                    step-strictly
                    :controls="false"
                  >
                  </el-input-number>
                  <span>瓦</span
                  ><span
                    style="
                      color: #fff;
                      width: 80px;
                      margin-left: 10px;
                      background: #409eff;
                      text-align: center;
                    "
                    >~</span
                  >
                  <el-input-number
                    v-model="items.keys"
                    @change="input_event2(indexs)"
                    :min="0"
                    :max="4000"
                    style="margin-right: 10px"
                    step-strictly
                    :controls="false"
                  ></el-input-number>
                  <span>瓦</span>
                  <span
                    style="
                      color: #fff;
                      width: 100px;
                      margin-left: 10px;
                      background: #409eff;
                      text-align: center;
                    "
                    >1小时</span
                  >
                  <el-input-number
                    v-model="items.value2"
                    :min="0"
                    :max="100"
                    style="margin-right: 10px"
                    step-strictly
                    :step="1"
                    :controls="false"
                  ></el-input-number>
                  <span style="margin-right: 10px">%</span>
                </div>
              </li>
            </div>
          </el-form-item>
          <el-divider
            v-if="MoneyInfo2.feeModelType == 4"
            content-position="center"
            >收费说明</el-divider
          >
          <el-form-item label="费用配置:" v-if="MoneyInfo2.feeModelType == 2">
            <div>
              <div v-for="(item, index) in timeList1" :key="index">
                <el-select v-model="item.type">
                  <el-option
                    v-for="item2 in options2"
                    :key="item2"
                    :value="item2"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="item.start"
                  style="width: 20%; margin-left: 10px"
                >
                  <el-option
                    v-for="(timeItem, timeIndex) in timeListAll"
                    :key="timeIndex"
                    :label="timeItem"
                    :value="timeItem"
                    :disabled="getBeginSelect(timeIndex)"
                  />
                </el-select>
                <span style="padding: 0 10px">-</span>
                <el-select
                  v-model="item.end"
                  style="width: 20%"
                  :disabled="!timeList1[index].start"
                >
                  <el-option
                    v-for="(timeItem, timeIndex) in timeListAll"
                    :key="timeIndex"
                    :label="timeItem"
                    :value="timeItem"
                    :disabled="getEndSelect(timeItem, timeIndex, index)"
                  />
                </el-select>
                <el-button
                  type="danger"
                  style="margin-left: 10px"
                  @click="delMethods(index)"
                  icon="el-icon-delete"
                  >删除</el-button
                >
              </div>
              <el-button
                type="primary"
                @click="addNewRange"
                :disabled="canAddNew()"
                >新增时间段</el-button
              >
            </div>
          </el-form-item>

          <el-form-item v-if="MoneyInfo2.feeModelType == 4">
            <div
              style="
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
                margin-left: -0px;
              "
            >
              <p
                v-if="shuzu[0].value2 > 0"
                style="width: 420px; margin-bottom: 10px"
              >
                <span v-if="shuzu[0].keys > 0" style="margin-right: 10px"
                  >1、&emsp;{{ shuzu[0].name }}&emsp;~&emsp;{{
                    shuzu[0].keys
                  }}瓦</span
                >
                <span v-else
                  >1、&emsp;{{ shuzu[0].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{
                    jisuanAPP(MoneyInfo2.fixFee, shuzu[0].value2, 2)
                  }}&ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;{{
                    jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[0].value2, 2)
                  }}元/时</span
                >
              </p>
              <p
                v-if="shuzu[1].value2 > 0"
                style="
                  width: 420px;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <span style="margin-right: 10px" v-if="shuzu[1].keys > 0"
                  >2、&emsp;{{ shuzu[1].name }}&emsp;~&emsp;{{
                    shuzu[1].keys
                  }}瓦</span
                >
                <span v-else
                  >2、&emsp;{{ shuzu[1].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{
                    jisuanAPP(MoneyInfo2.fixFee, shuzu[1].value2, 2)
                  }}&ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{
                    jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[1].value2, 2)
                  }}元/时</span
                >
              </p>
              <p
                v-if="shuzu[2].value2 > 0"
                style="width: 420px; margin-bottom: 10px"
              >
                <span style="margin-right: 10px" v-if="shuzu[2].keys > 0"
                  >3、&emsp;{{ shuzu[2].name }}&emsp;~&emsp;{{
                    shuzu[2].keys
                  }}瓦</span
                >
                <span v-else
                  >3、&emsp;{{ shuzu[2].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixFee, shuzu[2].value2, 2) }}
                  &ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[2].value2, 2) }}
                  元/时</span
                >
              </p>
              <p
                v-if="shuzu[3].value2 > 0"
                style="
                  width: 420px;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <span style="margin-right: 10px" v-if="shuzu[3].keys > 0"
                  >4、&emsp;{{ shuzu[3].name }}&emsp;~&emsp;{{
                    shuzu[3].keys
                  }}瓦</span
                >
                <span v-else
                  >4、&emsp;{{ shuzu[3].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixFee, shuzu[3].value2, 2) }}
                  &ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[3].value2, 2) }}
                  元/时</span
                >
              </p>
              <p
                v-if="shuzu[4].value2 > 0"
                style="width: 420px; margin-bottom: 10px"
              >
                <span style="margin-right: 10px" v-if="shuzu[4].keys > 0"
                  >5、&emsp;{{ shuzu[4].name }}&emsp;~&emsp;{{
                    shuzu[4].keys
                  }}瓦</span
                >
                <span v-else
                  >5、&emsp;{{ shuzu[4].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixFee, shuzu[4].value2, 2) }}&ensp;
                  元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[4].value2, 2) }}
                  元/时</span
                >
              </p>
              <p
                v-if="shuzu[5].value2 > 0"
                style="
                  width: 420px;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <span style="margin-right: 10px" v-if="shuzu[5].keys > 0"
                  >6、&emsp;{{ shuzu[5].name }}&emsp;~&emsp;{{
                    shuzu[5].keys
                  }}瓦</span
                >
                <span v-else
                  >6、&emsp;{{ shuzu[5].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixFee, shuzu[5].value2, 2) }}
                  &ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[5].value2, 2) }}
                  元/时</span
                >
              </p>
              <p
                v-if="shuzu[6].value2 > 0"
                style="width: 420px; margin-bottom: 10px"
              >
                <span style="margin-right: 10px" v-if="shuzu[6].keys > 0"
                  >7、&emsp;{{ shuzu[6].name }}&emsp;~&emsp;{{
                    shuzu[6].keys
                  }}瓦</span
                >
                <span v-else
                  >7、&emsp;{{ shuzu[6].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixFee, shuzu[6].value2, 2) }}
                  &ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[6].value2, 2) }}
                  元/时</span
                >
              </p>
              <p
                v-if="shuzu[7].value2 > 0"
                style="
                  width: 420px;
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <span style="margin-right: 10px" v-if="shuzu[7].keys > 0"
                  >8、&emsp;{{ shuzu[7].name }}&emsp;~&emsp;{{
                    shuzu[7].keys
                  }}瓦</span
                >
                <span v-else
                  >8、&emsp;{{ shuzu[7].name }}瓦&emsp;&emsp;以上&ensp;</span
                >
                <span style="margin-right: 10px"
                  >电费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixFee, shuzu[7].value2, 2) }}
                  &ensp;元/时</span
                ><span style="margin-right: 10px"
                  >服务费:&emsp;
                  {{ jisuanAPP(MoneyInfo2.fixServiceFee, shuzu[7].value2, 2) }}
                  元/时</span
                >
              </p>
            </div>
          </el-form-item>
          <el-divider content-position="center">充电方案</el-divider>
          <el-form-item>
            <li
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                padding-bottom: 10px;
              "
            >
              <span
                v-for="(item, index) in tablist"
                :key="index"
                @click="tabcheck(item.rateSchemeType)"
                :style="{
                  borderBottom:
                    activeIndex == item.rateSchemeType
                      ? '1px solid green'
                      : 'none',
                }"
                style="margin-right: 100px"
                >{{ item.name }}</span
              >
            </li>
            <li>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                <div
                  v-for="(item, index) in objArray"
                  :key="index"
                  style="
                    width: 200px;
                    margin: 5px 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    border: 1px solid green;
                  "
                >
                  <span
                    v-if="index !== 0"
                    style="
                      background-color: green;
                      color: #fff;
                      height: 100%;
                      width: 100px;
                      text-align: center;
                    "
                    >智能充电</span
                  >
                  <!-- type="number" -->
                  <input
                    v-if="index !== 0"
                    v-model="item[index]"
                    style="border: none; width: 20px; margin-left: 20px"
                  />
                  <span v-if="index !== 0" style="width: 40px">{{
                    activeIndex == 0 ? '元' : '小时'
                  }}</span>
                  <i
                    v-if="index !== 0"
                    class="el-icon-delete"
                    @click="edit_obj(index)"
                    style="width: 20px; text-align: center; color: red"
                  ></i>
                  <span
                    v-else
                    style="
                      background-color: green;
                      color: #fff;
                      width: 200px;
                      text-align: center;
                      height: 100%;
                    "
                    >智能充满</span
                  >
                </div>
              </div>
              <div>
                <el-button style="margin-left: 40%" @click="add_obj" v-if="adds"
                  >添加</el-button
                >
              </div>
            </li>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
          style="
            display: flex;
            justify-content: flex-end;
            margin-right: 5%;
            margin-top: 30px;
          "
        >
          <el-button @click="btn_click3">取 消</el-button>
          <el-button type="primary" v-debounce="editTariffs2">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-card class="card">
      <!--  -->
      <li
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin: -10px 0 10px -1%;
        "
      >
        <el-button
          v-if="tianjiadianzhan"
          type="success"
          icon="el-icon-plus"
          @click="showPowerStation(0)"
          >添加电站</el-button
        >
        <el-button
          v-if="shanchu"
          type="danger"
          icon="el-icon-delete"
          @click="removeById(0)"
          >批量删除</el-button
        >
      </li>
      <!-- table表格区域 -->
      <el-table
        class="table"
        :data="powerStationList"
        border
        @selection-change="handleSelectionChange"
        empty-text="暂无数据"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          label="名称"
          prop="stationName"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.stationName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="位置"
          prop="address"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.address }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="联系人"
          prop="contacts"
          width="90"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.contacts }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="卡密钥"
          prop="cardKey"
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cardKey }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="是否限定SOC"
          prop="isstopsoc"
          v-if="xianding"
          width="80"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.stationMode == 0"
              v-model="scope.row.isstopsoc"
              :active-value="0"
              :inactive-value="1"
              :active-color="scope.row.isstopsoc == 1 ? '#13ce66' : '#ff4949'"
              :inactive-color="scope.row.isstopsoc == 1 ? '#13ce66' : '#ff4949'"
              @change="enter_event(scope.row)"
            >
            </el-switch>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="限定SOC的值"
          prop="stopSOC"
          v-if="xianding"
          width="140"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.stationMode == 0">
              <el-input-number
                controls-position="right"
                v-model="scope.row.stopSOC"
                style="width: 90px; margin-right: 10px"
                @change="switch_event(scope.row)"
                :clearable="true"
                :min="0"
                :max="100"
                :disabled="scope.row.isstopsoc == 1 ? false : true"
                placeholder="请输入内容"
              ></el-input-number>
              <span>%</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="场站类型"
          prop="stationState"
          :show-overflow-tooltip="true"
          width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="stationColor(scope.row)">{{
              typeName(scope.row)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="二维码类型"
          prop="qrCodeType"
          :show-overflow-tooltip="true"
          width="120px"
        >
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.qrCodeType == 0 ? 'red' : '#000',
              }"
            >
              {{ scope.row.qrCodeType == 0 ? '互联互通二维码' : '通用二维码' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="停车类型"
          prop="parkType"
          :show-overflow-tooltip="true"
          width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="parkTypeColor(scope.row.parkType)">{{
              parkTypeName(scope.row.parkType)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="434">
          <template slot-scope="scope">
            <el-button
              size="small"
              icon="el-icon-top"
              :disabled="scope.row.s_c_anniu"
              @click="img_station(scope.row)"
              v-if="changzhantupian"
              >上传站图</el-button
            >
            <el-button
              icon="el-icon-help"
              size="small"
              v-if="j_z_l_feilvbianji"
              :type="scope.row.feeModelId == 0 ? '' : 'warning'"
              @click="showTariff(scope.row)"
              >充电策略</el-button
            >
            <el-button
              icon="el-icon-help"
              size="small"
              :type="scope.row.parkModelId == 0 ? '' : 'warning'"
              @click="stopCar(scope.row)"
              v-if="
                (celve && scope.row.parkType == 1) ||
                (celve && scope.row.parkType == 2)
              "
              >停车策略</el-button
            >
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              @click="showPowerStation(scope.row)"
              v-if="bianji"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[8, 20, 50, 100]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
// import { getMap } from 'echarts';
window._AMapSecurityConfig = {
  // 设置安全密钥
  securityJsCode: '36ffc476104cf8a1b5433c836cd27f72',
}
import caozuo from '@/utils/pubilc.js'
export default {
  name: 'PowerStation',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      xianding: false,
      roleType: window.sessionStorage.getItem('roleId') == 1 ? true : false,
      mapDialogVisible: false,
      districtData: null,
      cityData: null,
      provinceData: null,
      addressCounty: null,
      activeIndex: 0,
      adds: true,
      value1: ['', ''],
      map: null,
      radioMSK: [
        {
          qrCodeType: 0,
          name: '互联互通二维码',
        },
        {
          qrCodeType: 1,
          name: '通用二维码',
        },
      ],
      radioisInvoice: [
        {
          isInvoice: 0,
          name: '不开票',
        },
        {
          isInvoice: 1,
          name: '开票',
        },
      ],
      radioparkType: [
        {
          parkType: 0,
          name: '无停车',
        },
        {
          parkType: 1,
          name: '自营',
        },
        {
          parkType: 2,
          name: '自营(无设备)',
        },
        {
          parkType: 3,
          name: '第三方',
        },
      ],
      tablist: [
        {
          rateSchemeType: 0,
          name: '金额方案',
        },
        {
          rateSchemeType: 1,
          name: '时长方案',
        },
      ],
      list: [
        {
          paramKey: 0,
        },
        {
          paramKey: 0,
        },
        {
          paramKey: 0,
        },
        {
          paramKey: 0,
        },
      ],
      radioisInvoice: [
        {
          isInvoice: 0,
          name: '不开票',
        },
        {
          isInvoice: 1,
          name: '开票',
        },
      ],
      radioparkType: [
        {
          parkType: 0,
          name: '无停车',
        },
        {
          parkType: 1,
          name: '自营',
        },
        {
          parkType: 2,
          name: '自营(无设备)',
        },
        {
          parkType: 3,
          name: '第三方',
        },
      ],
      // 电站类型的列表
      stationTypeData: ['1', '50', '104', '100', '101', '102', '103', '255'],
      stateData: [
        {
          label: '正在规划',
          value: '0',
        },
        {
          label: '正在修建',
          value: '1',
        },
        {
          label: '仅供寻桩',
          value: '2',
        },
        {
          label: '正常运营',
          value: '3',
        },
        {
          label: '场站维护',
          value: '5',
        },
        {
          label: '场站停用',
          value: '6',
        },
      ],
      cardType: [
        {
          value: 0,
          label: '禁用刷卡',
        },
        {
          value: 1,
          label: '限本站卡',
        },
        {
          value: 2,
          label: '通用刷卡',
        },
      ],
      derateTypeData: [
        {
          label: '停车平台自行处理',
          value: 0,
        },
        {
          label: '减免金额',
          value: 1,
        },
        {
          label: '减免时长',
          value: 2,
        },
        {
          label: '折扣',
          value: 3,
        },
      ],
      radioMoney: [
        {
          orSas: 0,
          name: '分账',
        },
        {
          orSas: 1,
          name: '不分账',
        },
      ],
      typs: false,
      title: '',
      radioeletric: [
        {
          id: 0,
          name: '高速电站',
        },
        {
          id: 1,
          name: '低速电站',
        },
      ],
      consumptionTypepeData: [0, 1, 2, 3, 4, 5, 6],
      powerStationVisible: false,
      billingPolicy: {},
      timeListings: [
        {
          start: '00:00',
          end: '00:30',
          id: 1,
        },
        {
          start: '00:30',
          end: '01:00',
          id: 2,
        },
        {
          start: '01:00',
          end: '01:30',
          id: 3,
        },
        {
          start: '01:30',
          end: '02:00',
          id: 4,
        },
        {
          start: '02:00',
          end: '02:30',
          id: 5,
        },
        {
          start: '02:30',
          end: '03:00',
          id: 6,
        },
        {
          start: '03:00',
          end: '03:30',
          id: 7,
        },
        {
          start: '03:30',
          end: '04:00',
          id: 8,
        },
        {
          start: '04:00',
          end: '04:30',
          id: 9,
        },
        {
          start: '04:30',
          end: '05:00',
          id: 10,
        },
        {
          start: '05:00',
          end: '05:30',
          id: 11,
        },
        {
          start: '05:30',
          end: '06:00',
          id: 12,
        },
        {
          start: '06:00',
          end: '06:30',
          id: 13,
        },
        {
          start: '06:30',
          end: '07:00',
          id: 14,
        },
        {
          start: '07:00',
          end: '07:30',
          id: 15,
        },
        {
          start: '07:30',
          end: '08:00',
          id: 16,
        },
        {
          start: '08:00',
          end: '08:30',
          id: 17,
        },
        {
          start: '08:30',
          end: '09:00',
          id: 18,
        },
        {
          start: '09:00',
          end: '09:30',
          id: 19,
        },
        {
          start: '09:30',
          end: '10:00',
          id: 20,
        },
        {
          start: '10:00',
          end: '10:30',
          id: 21,
        },
        {
          start: '10:30',
          end: '11:00',
          id: 22,
        },
        {
          start: '11:00',
          end: '11:30',
          id: 23,
        },
        {
          start: '11:30',
          end: '12:00',
          id: 24,
        },
        {
          start: '12:00',
          end: '12:30',
          id: 25,
        },
        {
          start: '12:30',
          end: '13:00',
          id: 26,
        },
        {
          start: '13:00',
          end: '13:30',
          id: 27,
        },
        {
          start: '13:30',
          end: '14:00',
          id: 28,
        },
        {
          start: '14:00',
          end: '14:30',
          id: 29,
        },
        {
          start: '14:30',
          end: '15:00',
          id: 30,
        },
        {
          start: '15:00',
          end: '15:30',
          id: 31,
        },
        {
          start: '15:30',
          end: '16:00',
          id: 32,
        },
        {
          start: '16:00',
          end: '16:30',
          id: 33,
        },
        {
          start: '16:30',
          end: '17:00',
          id: 34,
        },
        {
          start: '17:00',
          end: '17:30',
          id: 35,
        },
        {
          start: '17:30',
          end: '18:00',
          id: 36,
        },
        {
          start: '18:00',
          end: '18:30',
          id: 37,
        },
        {
          start: '18:30',
          end: '19:00',
          id: 38,
        },
        {
          start: '19:00',
          end: '19:30',
          id: 39,
        },
        {
          start: '19:30',
          end: '20:00',
          id: 40,
        },
        {
          start: '20:00',
          end: '20:30',
          id: 41,
        },
        {
          start: '20:30',
          end: '21:00',
          id: 42,
        },
        {
          start: '21:00',
          end: '21:30',
          id: 43,
        },
        {
          start: '21:30',
          end: '22:00',
          id: 44,
        },
        {
          start: '22:00',
          end: '22:30',
          id: 45,
        },
        {
          start: '22:30',
          end: '23:00',
          id: 46,
        },
        {
          start: '23:00',
          end: '23:30',
          id: 47,
        },
        {
          start: '23:30',
          end: '24:00',
          id: 48,
        },
      ],
      timeList1: [
        {
          start: '',
          end: '',
          type: '尖时',
        },
      ],
      timeListAll: [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00',
        '06:30',
        '07:00',
        '07:30',
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
        '23:30',
        '24:00',
      ],
      options2: ['尖时', '峰时', '平时', '谷时'],
      total: 0,
      shuzu: [
        {
          name: '0',
          keys: '0',
          value2: '0',
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
        {
          name: '0',
          keys: '0',
          value2: 0,
        },
      ],
      celvDialog1: false,
      celvDialog2: false,
      tupian: this.$imgUrl,
      tianjiadianzhan: false,
      changzhantupian: false,
      j_z_l_feilvbianji: false,
      d_s_feilvbianji: false,
      celve: false,
      bianji: false,
      shanchu: false,
      editDialogVisible2: false,
      powerStationList: [],
      ids: '',
      // 低速
      radioArray2: [
        {
          id: 0,
          name: '固定时段计费',
        },
        {
          id: 2,
          name: '分时计费',
        },
        {
          id: 3,
          name: '固定费率',
        },
        {
          id: 4,
          name: '功率档费率',
        },
      ],
      // 交直流
      radioArray1: [
        {
          id: 0,
          name: '固定电费固定服务费',
        },
        {
          id: 1,
          name: '分时电费固定服务费',
        },
        {
          id: 2,
          name: '分时电费分时服务费',
        },
      ],
      bill: [],
      queryInfo: {
        stationIds: window.sessionStorage.getItem('stationIds'),
        name: '',
        contacts: '',
        contactsTel: '',
        stationState: 99,
        page: 1,
        limit: 8,
        orSas: 2,
        roleId: window.sessionStorage.getItem('roleId'),
        stationMode: '2',
      },
      stationModeList: [
        {
          label: '高速',
          value: '0',
        },
        {
          label: '低速',
          value: '1',
        },
        {
          label: '全部',
          value: '2',
        },
      ],
      orSasList: [
        {
          label: '分账',
          value: 0,
        },
        {
          label: '不分账',
          value: 1,
        },
        {
          label: '全部',
          value: 2,
        },
      ],
      stationStatelist: [
        {
          label: '规划',
          value: '0',
        },
        {
          label: '修建',
          value: '1',
        },
        {
          label: '仅供寻桩',
          value: '2',
        },
        {
          label: '正常运营',
          value: '3',
        },
        {
          label: '故障',
          value: '4',
        },
        {
          label: '维修',
          value: '5',
        },
        {
          label: '停用',
          value: '6',
        },
        {
          label: '全部',
          value: '99',
        },
      ],
      // 交直流
      MoneyInfo1: {
        feeModelType: 0,
        tip: 0.0001,
        tipService: 0,
        peak: 0.0001,
        peakService: 0,
        flat: 0.0001,
        flatService: 0,
        valley: 0.0001,
        valleyService: 0,
        billingPolicy: {},
        feeModelType: 0,
        fixFee: 0.0001,
        fixServiceFee: 0,
        timeFeeModel: {},
      },
      ids_all: null,
      feeModelType: null,
      feeModelId: null,
      // 低速
      MoneyInfo2: {
        feeModelType: 2,
        feeModelType: 0,
        fixFee: 0.0001,
        fixServiceFee:0,
        timeFeeModel: {},
      },
      imgVisible: false,
      // 停车策略
      carInfo: {
        billingPolicy: 0,
        timeFeeModel: 0,
        fixFee: 0.0001,
        fixServiceFee: 0,
        feeModelType: 0,
        parkModelId: 0,
      },
      ImageInfo: {},
      stationInfo: {
        stationMode: 0,
        orSas: 0,
        name: '',
        derateType: 0,
        derateValue: '',
        outMcNo: '',
        parkModelThreeId: '',
        id: null,
        isInvoice: 0,
        qrCodeType: 0,
        consumptionType: 0,
        parkType: 0,
        stationName: '',
        address: '',
        longitude: '',
        latitude: '',
        contacts: '',
        contactsTel: '',
        stationState: '3',
        field: '24h',
        icState: 2,
        feeModelDisplay: 1,
        brokenNetCharging: 0,
        hlhtEquipmentOwnerId: '',
        stationType: 1,
        stationDisplay: '1',
        brokenNet: 0,
        totalPower: 0,
        id: '',
        notice: '',
        parking: '',
        noticeEndTime: '',
        noticeStartTime: '',
        parkModelId: '',
      },
      billingPolicy2: {
        tip: 0.0001,
        tipService: 0.0001,
        peak: 0.0001,
        peakService: 0.0001,
        flat: 0.0001,
        flatService: 0.0001,
        valley: 0.0001,
        valleyService: 0.0001,
      },
      placeSearch: null,
      auto: null,
      keyword: '',
      carTypeData: [],
      imgg: '',
      imgges: '',
      fileList: [],
      imgId: null,
      newfilelist: [],
      groupedData: [],
      matchedIds: null,
      // 功率档位
      objArray: [],
      newarray: [],
      liebiao: null,
      colors: ['#409eff', '#67c23a', '#909399', '#e6a23c'],
      parkid: null,
      zhuangtai: '99',
      fenzhang: 2,
      moshi: '2',
      objjc: {
        0: '规划',
        1: '修建',
        2: '仅供寻桩',
        3: '正常运营',
        4: '故障',
        5: '维修',
        6: '停用',
      },
      objja: {
        1: '公共场站',
        50: '个人专用',
        100: '公交专用',
        101: '环卫(专用)',
        102: '物流(专用)',
        103: '出租车(专用)',
        104: '内部专用',
        254: '测试专用',
        255: '其他',
      },
    }
  },
  computed: {
    parkTypeColor() {
      return (obj) => {
        const objj = {
          0: 'primary',
          1: 'warning',
          2: 'success',
          default: 'danger',
        }
        return objj[obj] || objj.default
      }
    },
    parkTypeName() {
      return (obj) => {
        const objj = {
          0: '无停车',
          1: '自营',
          2: '自营(无设备)',
          default: '第三方',
        }
        return objj[obj] || objj.default
      }
    },
    stationColor() {
      return (obj) => {
        const { stationState, stationType } = obj
        if (stationState !== '3') {
          return 'default'
        }
        if (
          this.objja[stationType] == '规划修建' ||
          this.objja[stationType] == '仅供寻桩'
        ) {
          return 'default'
        }
        if (this.objja[stationType] == '公共场站') {
          return 'success'
        }
        if (
          this.objja[stationType] == '故障维修' ||
          this.objja[stationType] == '场站停用'
        ) {
          return 'error'
        }
        if (
          this.objja[stationType] == '个人专用' ||
          this.objja[stationType] == '公交专用' ||
          this.objja[stationType] == '环卫(专用)' ||
          this.objja[stationType] == '物流(专用)' ||
          this.objja[stationType] == '出租车(专用)' ||
          this.objja[stationType] == '内部专用'
        ) {
          return 'primary'
        }
        if (this.objja[stationType] == '测试专用') {
          return 'warning'
        }
        return 'royal'
      }
    },
    typeName() {
      return (obj) => {
        const { stationState, stationType } = obj
        return stationState == 3
          ? this.objja[stationType]
          : this.objjc[stationState]
      }
    },
    jisuan() {
      return (obj, num, fixed) => {
        return obj == null || obj == undefined || obj == ''
          ? '--'
          : (obj / num).toFixed(fixed)
      }
    },

    jisuanAPP() {
      return function (abc, bac, num) {
        if (bac !== 0) {
          const hr = ((Number(bac) * Number(abc)) / 100).toFixed(num)
          return hr
        } else {
          return 0
        }
      }
    },
  },
  watch: {
    fenzhang(newvalue) {
      if (newvalue == 2) {
        this.$delete(this.queryInfo, 'orSas')
        return
      }
      this.queryInfo.orSas = newvalue
    },
    moshi(newvalue) {
      if (newvalue == 2) {
        this.queryInfo.stationMode = '0,1,2'
        return
      }
      this.queryInfo.stationMode = newvalue
    },
    zhuangtai(newvalue) {
      if (newvalue == 99) {
        this.$delete(this.queryInfo, 'stationState')
        return
      }
      this.queryInfo.stationState = newvalue
    },
    // 充电金额方案
    objArray(newvalue) {
      if (newvalue == null || newvalue == undefined || newvalue == '') return
      this.objArray = newvalue
      if (newvalue.length < 6) {
        this.adds = true
      } else {
        this.adds = false
      }
    },
    // 时段收费方案
    liebiao(newvalue) {
      if (newvalue == null || newvalue == undefined || newvalue == '') return
      this.liebiao = newvalue
      if (newvalue.length < 24 && newvalue.length > 0)
        return (this.adds_btn = true)
      return (this.adds_btn = false)
    },
    newarray(newvalue) {
      if (newvalue.length < 2) return
      this.objArray = newvalue
    },
  },
  created() {
    // 权限判断
    caozuo(161).then((res) => {
      this.tianjiadianzhan = res
    })
    caozuo(153).then((ress) => {
      this.changzhantupian = ress
    })
    caozuo(94).then((resb) => {
      this.j_z_l_feilvbianji = resb
    })
    caozuo(175).then((resb) => {
      this.d_s_feilvbianji = resb
    })
    caozuo(174).then((rese) => {
      this.celve = rese
    })
    caozuo(154).then((rese) => {
      this.bianji = rese
    })
    caozuo(155).then((resr) => {
      this.shanchu = resr
    })
    caozuo(225).then((resr) => {
      this.xianding = resr
    })
    this.queryInfo.stationMode = '0,1,2'
    this.$delete(this.queryInfo, 'orSas')
    this.$delete(this.queryInfo, 'stationState')
    if (
      window.sessionStorage.getItem('roleId') == 1 ||
      window.sessionStorage.getItem('roleId') == 2 ||
      window.sessionStorage.getItem('roleId') == 3 ||
      window.sessionStorage.getItem('roleId') == 10
    ) {
      this.$delete(this.queryInfo, 'stationIds')
    } else {
      this.queryInfo.stationIds = window.sessionStorage.getItem('stationIds')
    }
    this.$http
      .get('three-parking-api/getAllThreeParkingApi', {
        params: this.queryInfo,
      })
      .then((res) => {
        if (res.data.code !== 0) return
        this.carTypeData = res.data.data
      })
  },
  mounted() {
    // table表格
    this.getPowerStationList()
  },
  methods: {
    // 交直流监听费率// 清空时强制设为最小值1
    handleInput() {
        this.MoneyInfo1.fixFee = this.MoneyInfo1.fixFee||0.0001
        this.MoneyInfo1.fixServiceFee = this.MoneyInfo1.fixServiceFee||0
        this.MoneyInfo1.tip = this.MoneyInfo1.tip||0.0001
        this.MoneyInfo1.tipService =this.MoneyInfo1.tipService||0
        this.MoneyInfo1.peak =this.MoneyInfo1.peak|| 0.0001
        this.MoneyInfo1.peakService = this.MoneyInfo1.peakService||0
        this.MoneyInfo1.flat = this.MoneyInfo1.flat||0.0001
        this.MoneyInfo1.flatService = this.MoneyInfo1.flatService||0
        this.MoneyInfo1.valley = this.MoneyInfo1.valley||0.0001
        this.MoneyInfo1.valleyService = this.MoneyInfo1.valleyService||0
    },
    // 低速听费率// 清空时强制设为最小值1
    handleInput2(){
      this.MoneyInfo2.fixFee = this.MoneyInfo2.fixFee||0.0001
        this.MoneyInfo2.fixServiceFee = this.MoneyInfo2.fixServiceFee||0
        this.MoneyInfo2.tip = this.MoneyInfo2.tip||0.0001
        this.MoneyInfo2.tipService =this.MoneyInfo2.tipService||0
        this.MoneyInfo2.peak =this.MoneyInfo2.peak|| 0.0001
        this.MoneyInfo2.peakService = this.MoneyInfo2.peakService||0
        this.MoneyInfo2.flat = this.MoneyInfo2.flat||0.0001
        this.MoneyInfo2.flatService = this.MoneyInfo2.flatService||0
        this.MoneyInfo2.valley = this.MoneyInfo2.valley||0.0001
        this.MoneyInfo2.valleyService = this.MoneyInfo2.valleyService||0
    },
    jianmian() {},
    chaxun() {
      this.queryInfo.page = 1
      this.getPowerStationList()
    },
    enter_event(row) {
      const that = this
      that
        .$confirm('此操作将修改soc状态，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          row.isstopsoc =
            row.isstopsoc == true
              ? 1
              : row.isstopsoc == false
              ? 0
              : row.isstopsoc
          that.$http
            .post(`/station-info/updateSocById/${row.id}/${row.isstopsoc}`)
            .then((res) => {
              that.$message({
                message: res.data.code == 0 ? 'soc更新成功' : res.data.msg,
                type: res.data.code == 0 ? 'success' : 'error',
              })
              if (res.data.code == 0) return that.getPowerStationList()
            })
        })
        .ceatch(() => {
          return that.$message.info(`已取消修改soc状态`)
        })
    },
    // 省
    async getProvinceData() {
      this.$http.get('sysArea/getAllSysArea').then((res) => {
        if (res.data.code !== 0) return this.$message.error(res.data.msg)
        this.provinceData = res.data.data
      })
    },
    // 省改变
    provinceChange(value) {
      this.getCityData(value)
      this.addressCounty.cityName = ''
      this.addressCounty.districtName = ''
      this.addressCounty.provinceId = value
    },
    // 市
    async getCityData(id) {
      this.$http.get('sysArea/getAreaCityByParentId/' + id)
      console.log(res)
      if (res.code !== 0) return this.$message.error(res.msg)
      this.cityData = res.data
    },
    // 城市改变（没用到）
    cityChange(value) {
      this.getDistrictData(value)
      this.addressCounty.districtName = ''
      this.addressCounty.cityId = value
    },
    // 区、县
    async getDistrictData(id) {
      this.$http.get('sysArea/getAreaCountyByParentId/' + id)
      console.log(res)
      if (res.code !== 0) return this.$message.error(res.msg)
      this.districtData = res.data
    },
    // 选择位置取消（地图组件）
    qx4() {
      this.keyword = this.stationInfo.address
      this.initAMap()
    },
    editMapPosition() {
      this.stationInfo.address =
        this.keyword !== null ? this.keyword : this.stationInfo.address
      this.mapDialogVisible = false
    },
    // 关键字查询
    searchMap() {
      // 搜索框自动完成类
      this.auto = new AMap.AutoComplete({
        input: 'tipinput', // 使用联想输入的input的id
        city: '全国',
      })
      //构造地点查询类
      this.placeSearch = new AMap.PlaceSearch({
        map: this.map,
        city: this.keyword,
      })
      // 当选中某条搜索记录时触发
      this.placeSearch.search(this.keyword, function (status, result) {
        // this.stationInfo.address=result;
        // console.log(status)
        // console.log(result,'1185')
      })
    },
    initAMap() {
      const that = this
      let markers = []
      AMapLoader.load({
        key: '9747ad6cffe4a3e286980b02cbff8a41', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          'AMap.ToolBar',
          'AMap.Scale',
          'AMap.Geocoder',
          'AMap.Geolocation',
          'AMap.PlaceSearch',
          'AMap.AutoComplete',
          'AMap.CitySearch',
        ],
        resizeEnable: true,
      })
        .then((AMap) => {
          that.map = new AMap.Map('container', {
            // 设置地图容器id
            viewMode: '3D', // 是否为3D地图模式
            zoom: 15, // 初始化地图级别
            center: [112.453868, 34.619631], // 初始化地图中心点位置
            resizeEnable: true,
          })
          // 关键字查询
          that.searchMap()
          // 选中logo（定位）
          that.map.on('click', function (e) {
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              '' +
              '<div class="custom-content-marker">' +
              '   <img src="//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png">' +
              // '   <div class="close-btn" onclick="clearMarker()">X</div>' +
              '</div>'

            const position = new AMap.LngLat(
              e.lnglat.getLng(),
              e.lnglat.getLat()
            ) //Marker经纬度
            this.remove(markers)
            const marker = new AMap.Marker({
              position: position,
              icon: new AMap.Icon({
                image:
                  '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                size: [20, 30],
              }),
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-20, -28),
            })
            markers.push(marker)
            this.add(marker)
            that.stationInfo.longitude = e.lnglat.getLng()
            that.stationInfo.latitude = e.lnglat.getLat()
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    searchKeyWord() {
      this.initAMap()
    },
    getMap() {
      this.mapDialogVisible = true
      this.keyword = this.stationInfo.address
      this.initAMap()
    },
    //功率分档定价（切换充电方案）
    tabcheck(e) {
      this.activeIndex = e
      this.objArray = [{ 0: '0' }]
    },
    // 添加充电金额方案
    add_obj() {
      if (this.objArray.length < 1) {
        this.objArray = [{ 0: '0' }]
      } else {
        this.objArray.push({})
      }
    },
    // 删除充电金额方案
    edit_obj(e) {
      const that = this
      if (that.objArray.length < 2)
        return this.$message('请至少保留一项充电方案')
      that.objArray.forEach((item, index) => {
        if (index == e) {
          that.objArray.splice(index, 1)
        }
      })
    },
    delMethods(e) {
      if (this.timeList1.length < 2)
        return this.$message.error('必须保留一项！')
      this.timeList1.forEach((item, index) => {
        if (index == e) {
          this.timeList1.splice(index, 1)
        }
      })
    },
    parkType_change(e) {
      const that = this
      if (e !== 3) return that.stationInfo
    },
    // 时间设置
    changeTimeall(value) {
      if (value.length !== 0) {
        this.stationInfo.startTime = value[0] == value[1] ? '' : value[0]
        this.stationInfo.endTime = value[0] == value[1] ? '' : value[1]
        if (value[0] == value[1])
          return this.$message.error('起始时间不得为同一天！')
      } else {
        this.stationInfo.noticeStartTime = ''
        this.stationInfo.noticeEndTime = ''
      }
    },
    editPowerStation() {
      const {
        contacts,
        contactsTel,
        totalPower,
        address,
        longitude,
        parkType,
        parkModelId,
        stationMode,
        outMcNo,
        latitude,
      } = this.stationInfo
      this.stationInfo.adminId = window.sessionStorage.getItem('adminId') * 1
      if (contacts == '' || !contacts)
        return this.$message.error('请输入联系人姓名')
      if (contactsTel == '' || !contactsTel)
        return this.$message.error('请输入联系人电话')
      if (totalPower == '' || !totalPower) {
        this.stationInfo.totalPower = 0
      }
      // return this.$message.error('请输入电站总功率')
      if (address == '' || longitude == '' || latitude == '')
        return this.$message.error('请选择电站地址')
      if (parkType == 2) {
        this.stationInfo.parkModelId = ''
      }
      this.stationInfo.parkModelThreeId = parkType == 3 ? parkModelId : ''
      if (parkType == 3) {
        if (outMcNo == '' || !outMcNo)
          return this.$message.error('第三方停车，车场编号为必传项')
      }
      if (!stationMode) {
        this.stationInfo.stationMode = 0
      }
      if (this.title == '添加电站') {
        this.$http
          .post('station-info/addStationInfo', this.stationInfo)
          .then((res) => {
            const { code } = res.data
            this.$message({
              message: code == 0 ? '添加电站成功！' : '添加电站失败',
              type: code == 0 ? 'success' : 'error',
            })
            this.powerStationVisible = false
            this.value1 = ['', '']
            if (code == 0) return this.getPowerStationList()
          })
        return
      }
      this.stationInfo.id = this.allid
      this.$http
        .post('station-info/updStationInfo', this.stationInfo)
        .then((ress) => {
          const { code } = ress.data
          if (code !== 0) return
          console.log(this.stationInfo.qrCodeType, '3247')
          this.$message({
            message: code == 0 ? '编辑电站成功！' : '编辑电站失败',
            type: code == 0 ? 'success' : 'error',
          })
          this.erweima()
          // this.getPowerStationList()
          // this.powerStationVisible = false;
        })
    },
    // 后期改，目前不知道为什么--二维码类型修改失败
    erweima() {
      this.$http
        .post('station-info/updStationInfo', {
          id: this.stationInfo.id,
          qrCodeType: this.stationInfo.qrCodeType,
          stationMode: this.stationInfo.stationMode,
        })
        .then((res) => {
          const { code } = res.data
          if (code !== 0) return
          this.getPowerStationList()
          this.powerStationVisible = false
        })
    },
    // 费率（拖拽改变）
    getBeginSelect(timeIndex) {
      // 最后一个时间不可选
      if (timeIndex == this.timeListAll.length - 1) {
        return true
      }
      // 循环判断时间段是否被占用
      let temp = false
      this.timeList1.forEach((timeList1Item) => {
        // 没选择完时间的不计算
        if (timeList1Item.start && timeList1Item.end) {
          const startIndex = this.timeListAll.findIndex(
            (timeItem) => timeItem == timeList1Item.start
          )
          const endIndex = this.timeListAll.findIndex(
            (timeItem) => timeItem == timeList1Item.end
          )
          if (timeIndex >= startIndex && timeIndex < endIndex) {
            temp = true
          }
        }
      })
      if (temp) {
        return true
      }
      return false
    },
    // 费率（拖拽改变）
    getEndSelect(timeItem, timeIndex, index) {
      // 当前的开始时间 前面的都不能选
      const currentBeginIndex = this.timeListAll.findIndex(
        (timeItem) => timeItem == this.timeList1[index].start
      )
      if (timeIndex <= currentBeginIndex) {
        return true
      }

      // 循环判断时间段是否被占用
      let temp = false
      this.timeList1.forEach((timeList1Item, timeList1Index) => {
        if (timeList1Index == index) {
          return
        }
        if (timeList1Item.start && timeList1Item.end) {
          const startIndex = this.timeListAll.findIndex(
            (timeItem) => timeItem == timeList1Item.start
          )
          const endIndex = this.timeListAll.findIndex(
            (timeItem) => timeItem == timeList1Item.end
          )
          if (timeIndex > startIndex && timeIndex <= endIndex) {
            temp = true
          }
        }
      })
      if (temp) {
        return true
      }

      // 只能选择到  下一次的时间段之前的
      let sortList = []
      this.timeList1.forEach((timeList1Item) => {
        sortList.push(timeList1Item.start)
      })
      let newList = sortList.sort()
      const currentIndex = newList.findIndex((item) => item == timeItem)
      if (currentIndex != newList.length - 1) {
        const nextTimeIndex = newList.findIndex(
          (item) => item == newList[currentIndex + 1]
        )
        if (timeItem < nextTimeIndex) {
          return true
        }
      }
      return false
    },
    // 费率（拖拽改变）
    canAddNew() {
      let timeRange = []
      this.timeList1.forEach((timeList1Item) => {
        if (timeList1Item.start && timeList1Item.end) {
          timeRange.push(timeList1Item.start)
          timeRange.push(timeList1Item.end)
        }
      })
      const timeList = timeRange.sort()
      if (
        timeList[0] == this.timeListAll[0] &&
        timeList[timeList.length - 1] ==
          this.timeListAll[this.timeListAll.length - 1] &&
        this.getadjoinSame(timeList)
      ) {
        return true
      }
      return false
    },
    // 费率（拖拽改变）
    getadjoinSame(timeList) {
      var temp = true
      const newList = timeList.slice(1, -1)
      for (let i = 0; i < newList.length / 2; i++) {
        if (newList[i * 2] != newList[i * 2 + 1]) {
          temp = false
        }
      }
      return temp
    },
    // 添加&编辑对话框的关闭事件
    powerStationDialogClosed() {
      this.$refs.powerStationRef.resetFields()
      this.powerStationVisible = false
      // this.powerStationList.forEach(item => {
      //   item.b_j_anniu = false;
      // });
    },
    // 修改电站类别
    radioelerc_change(e) {
      this.stationInfo.stationMode = e
    },
    input_event1(index) {
      console.log(that.shuzu, '1731')
      const that = this
      if (index == 0) return
      that.shuzu[index - 1].keys = that.shuzu[index].name - 1
      if (
        that.shuzu[index].keys < that.shuzu[index].name ||
        that.shuzu[index].keys == that.shuzu[index].name
      ) {
        return that.$message.error(
          '档位开始功率不得大于或等于结束功率，请仔细核对后再上传费率'
        )
      }
    },
    input_event2(index) {
      const that = this
      if (index == 0)
        return (that.shuzu[index + 1].name = that.shuzu[index].keys * 1 + 1)
      that.shuzu[index].keys = that.shuzu[index].keys
      that.shuzu[index - 1].keys = that.shuzu[index].name - 1
      that.shuzu[index + 1].name = that.shuzu[index].keys * 1 + 1 * 1
    },
    // 添加时段
    addNewRange() {
      // const lastEnd = this.timeList1[this.timeList1.length - 1].end;
      this.timeList1.push({
        start: null,
        end: null,
        type: '尖时',
      })
    },
    // 同意：交直流费率
    editTariffs1() {
      const that = this
      if (that.timeList1.length > 0) {
        that.timeList1 = that.timeList1.filter((item) => {
          return typeof item !== 'string'
        })
      }
      if (that.MoneyInfo1.feeModelType !== 0 && that.timeList1.length == 0)
        return that.$message.error('请选择你的费率时间段！')
      let abc =
        that.MoneyInfo1.feeModelType == 0
          ? ''
          : JSON.stringify({
              tip: (that.MoneyInfo1.tip * 10000).toFixed(0),
              tipService:
                that.MoneyInfo1.feeModelType == 1
                  ? (that.MoneyInfo1.fixServiceFee * 10000).toFixed(0)
                  : (that.MoneyInfo1.tipService * 10000).toFixed(0),
              peak: (that.MoneyInfo1.peak * 10000).toFixed(0),
              peakService:
                that.MoneyInfo1.feeModelType == 1
                  ? (that.MoneyInfo1.fixServiceFee * 10000).toFixed(0)
                  : (that.MoneyInfo1.peakService * 10000).toFixed(0),
              flat: (that.MoneyInfo1.flat * 10000).toFixed(0),
              flatService:
                that.MoneyInfo1.feeModelType == 1
                  ? (that.MoneyInfo1.fixServiceFee * 10000).toFixed(0)
                  : (that.MoneyInfo1.flatService * 10000).toFixed(0),
              valley: (that.MoneyInfo1.valley * 10000).toFixed(0),
              valleyService:
                that.MoneyInfo1.feeModelType == 1
                  ? (that.MoneyInfo1.fixServiceFee * 10000).toFixed(0)
                  : (that.MoneyInfo1.valleyService * 10000).toFixed(0),
            })
      if (that.MoneyInfo1.feeModelType > 0) {
        that.processTimeRanges()
      }
      that.MoneyInfo1.stationId =
        that.MoneyInfo1.feeModelId == 0 ? null : that.ids_all
      that.$http
        .post('feeModel/addFeeModel', {
          billingPolicy: abc,
          timeFeeModel:
            that.MoneyInfo1.feeModelType == 0 ? '' : JSON.stringify(that.bill),
          createTime: that.MoneyInfo1.createTime,
          feeModelType: that.MoneyInfo1.feeModelType,
          fixFee: (that.MoneyInfo1.fixFee * 10000).toFixed(0),
          fixServiceFee: (that.MoneyInfo1.fixServiceFee * 10000).toFixed(0),
          stationId: that.ids_all,
          id: that.feeModelId,
          stationName: that.MoneyInfo1.stationName,
          adminId: window.sessionStorage.getItem('adminId') * 1,
          timeJson:
            that.MoneyInfo1.feeModelType !== 0
              ? JSON.stringify(that.timeList1)
              : '',
        })
        .then((res) => {
          that.celvDialog1 = false
          this.$message({
            message: res.data.code !== 0 ? '修改费率失败！' : '修改费率成功！',
            type: res.data.code !== 0 ? 'error' : 'success',
          })
          if (res.data.code !== 0) {
            that.pubilc_function1()
          }
          that.getPowerStationList()
        })
    },

    // 时间转换方法
    timeToMinutes(timeStr) {
      if (timeStr == null || timeStr == undefined || timeStr == '') {
        return false
      } else {
        const [hours, mins] = timeStr.split(':').map(Number)
        return hours * 60 + mins
      }
    },
    // 处理时间范围的核心方法
    processTimeRanges() {
      const that = this
      // 转换主时间段为分钟数
      const convertedRanges = that.timeList1.map((range) => ({
        start: that.timeToMinutes(range.start),
        end: that.timeToMinutes(range.end),
      }))
      // 初始化结果数组(对)
      console.log(convertedRanges, '1391')
      // 初始化结果数组（跨时段，不进入此方法函数）
      const groups = that.timeList1.map((_, index) => ({
        key: `key${index}`,
        ids: [],
        color: _.type,
      }))
      let ntr = that.timeListings
      // 处理每个时间段
      ntr.forEach((item) => {
        const start = that.timeToMinutes(item.start)
        const end = that.timeToMinutes(item.end)
        for (let i = 0; i < convertedRanges.length; i++) {
          const range = convertedRanges[i]
          if (start >= range.start && end <= range.end) {
            groups[i].ids.push(item.id)
            break
          }
        }
      })
      that.billingPolicy = groups
      that.jisuanMethods()
    },
    jisuanMethods() {
      const that = this
      var arr = []
      that.bill = {}
      if (that.billingPolicy.length == 1) {
        arr = that.billingPolicy[0].ids
        console.log(arr, '3529')
        arr.forEach((item) => {
          // const key = item;
          let value =
            that.billingPolicy[0].color == '尖时'
              ? that.colors[0]
              : that.billingPolicy[0].color == '峰时'
              ? that.colors[1]
              : that.billingPolicy[0].color == '平时'
              ? that.colors[2]
              : that.billingPolicy[0].color == '谷时'
              ? that.colors[3]
              : ''
          that.bill[item] = value
        })
        // arr.forEach((item) => {
        //   const key = item;
        //   const value =
        //     that.billingPolicy[0].color == '尖时'
        //       ? that.colors[0]
        //       : that.billingPolicy[0].color == '峰时'
        //         ? that.colors[1]
        //         : that.billingPolicy[0].color == '平时'
        //           ? that.colors[2]
        //           : that.billingPolicy[0].color == '谷时'
        //             ? that.colors[3]
        //             : ''
        //   that.bill[key] = value
        // })
      } else {
        that.bill = that.billingPolicy.reduce((acc, policy) => {
          const { ids, color } = policy
          ids.forEach((id) => {
            acc[id] =
              color == '尖时'
                ? that.colors[0]
                : color == '峰时'
                ? that.colors[1]
                : color == '平时'
                ? that.colors[2]
                : color == '谷时'
                ? that.colors[3]
                : '' // 将每个 id 作为 key，color 作为 value:ml-citation{ref="8" data="citationList"}
          })
          return acc
        }, {})
      }
    },
    // 同意：低速费率
    editTariffs2() {
      const that = this
      if (that.MoneyInfo2.feeModelType == 2) {
        that.processTimeRanges()
      }
      // console.log(that.bill,'1066');
      let abc = ''
      if (that.MoneyInfo2.feeModelType == 4) {
        if (
          that.shuzu.length == 0 ||
          that.shuzu == null ||
          that.shuzu == undefined ||
          that.shuzu == ''
        )
          return that.$message.error('请输入档位计费的详细信息')
        abc = `1、${that.shuzu[0].name}瓦~${that.shuzu[0].keys}瓦，电费${(
          (Number(that.shuzu[0].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[0].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        2、${that.shuzu[1].name}瓦~${that.shuzu[1].keys}瓦，电费${(
          (Number(that.shuzu[1].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[1].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        3、${that.shuzu[2].name}瓦~${that.shuzu[2].keys}瓦，电费${(
          (Number(that.shuzu[2].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[2].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        4、${that.shuzu[3].name}瓦~${that.shuzu[3].keys}瓦，电费${(
          (Number(that.shuzu[3].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[3].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        5、${that.shuzu[4].name}瓦~${that.shuzu[4].keys}瓦，电费${(
          (Number(that.shuzu[4].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[4].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        6、${that.shuzu[5].name}瓦~${that.shuzu[5].keys}瓦，电费${(
          (Number(that.shuzu[5].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[5].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        7、${that.shuzu[6].name}瓦~${that.shuzu[6].keys}瓦，电费${(
          (Number(that.shuzu[6].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[6].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;
        8、${that.shuzu[7].name}瓦~${that.shuzu[7].keys}瓦，电费${(
          (Number(that.shuzu[7].value2) * Number(that.MoneyInfo2.fixFee)) /
          100
        ).toFixed(2)}元/时，服务费${(
          (Number(that.shuzu[7].value2) *
            Number(that.MoneyInfo2.fixServiceFee)) /
          100
        ).toFixed(2)}元/时;`
      }
      console.log(
        that.MoneyInfo2.rateSchemeType,
        that.MoneyInfo2.feeModelType,
        '2137'
      )
      that.$http
        .post('feeModel/updLowFeeModel', {
          createTime: that.MoneyInfo2.createTime,
          duration: that.MoneyInfo2.duration * 1,
          feeModelType: that.MoneyInfo2.feeModelType,
          rateSchemeType:
            that.MoneyInfo2.feeModelType == 2 ||
            that.MoneyInfo2.feeModelType == 0
              ? 0
              : that.MoneyInfo2.rateSchemeType,
          rateScheme: JSON.stringify(that.objArray),
          fixFee:
            that.MoneyInfo2.feeModelType == 0 ||
            that.MoneyInfo2.feeModelType == 2
              ? that.MoneyInfo2.fixFee * 1000
              : that.MoneyInfo2.fixFee * 100,
          fixServiceFee:
            (that.MoneyInfo2.feeModelType == 0 ||
              that.MoneyInfo2.feeModelType == 2) &&
            (that.MoneyInfo2.fixServiceFee * 100).toFixed(0).length < 3
              ? that.MoneyInfo2.fixServiceFee * 1000
              : that.MoneyInfo2.fixServiceFee * 100,
          stationId: that.ids_all,
          id: that.MoneyInfo2.id,
          stationName: that.MoneyInfo2.stationName,
          adminId: window.sessionStorage.getItem('adminId') * 1,
          billingPolicy:
            that.MoneyInfo2.feeModelType == 4
              ? JSON.stringify(that.shuzu)
              : that.MoneyInfo2.feeModelType == 2
              ? JSON.stringify({
                  tip: (that.billingPolicy2.tip * 1000).toFixed(0),
                  tipService: (that.billingPolicy2.tipService * 1000).toFixed(
                    0
                  ),
                  peak: (that.billingPolicy2.peak * 1000).toFixed(0),
                  peakService: (that.billingPolicy2.peakService * 1000).toFixed(
                    0
                  ),
                  flat: (that.billingPolicy2.flat * 1000).toFixed(0),
                  flatService: (that.billingPolicy2.flatService * 1000).toFixed(
                    0
                  ),
                  valley: (that.billingPolicy2.valley * 1000).toFixed(0),
                  valleyService: (
                    that.billingPolicy2.valleyService * 1000
                  ).toFixed(0),
                })
              : '',
          timeFeeModel:
            that.MoneyInfo2.feeModelType == 2
              ? JSON.stringify(that.bill)
              : that.MoneyInfo2.feeModelType == 4
              ? abc
              : '',
          timeJson:
            that.MoneyInfo2.feeModelType == 2
              ? JSON.stringify(that.timeList1)
              : '',
        })
        .then((res) => {
          that.celvDialog2 = false
          that.$message({
            message:
              res.data.code == 0 ? '低速费率设置成功' : '低速费率设置失败',
            type: res.data.code == 0 ? 'success' : 'error',
          })
          if (res.data.code !== 0) {
            that.pubilc_function2()
          }
          that.editDialogVisibles = false
          that.getPowerStationList()
        })
    },
    handleTimeChange() {
      this.$refs.timeForm.validateField('timeList')
    },
    // 同意：停车策略
    editTariff2() {
      const that = this
      if (
        that.carInfo.fixFee == '' ||
        that.carInfo.fixFee == null ||
        that.carInfo.fixFee == undefined
      )
        return that.$message.error('占位费为必传项')
      // if (that.carInfo.fixServiceFee.includes('.')) return that.carInfo.fixServiceFee = that.carInfo.fixServiceFee.split('.')[0];
      that.carInfo.feeModelType = that.feeModelType == 0 ? 5 : 6
      that.$http
        .post('feeModel/updGLModel', {
          feeModelType: that.carInfo.feeModelType,
          fixFee: parseFloat(that.carInfo.fixFee * 100),
          fixServiceFee: parseFloat(that.carInfo.fixServiceFee),
          // fixServiceFee: that.carInfo.feeModelType == 5 ?  : 0,
          stationId: that.ids_all,
          id: that.parkModelId,
          adminId: window.sessionStorage.getItem('adminId') * 1,
          stationMode: that.stationMode,
          billingPolicy: that.carInfo.billingPolicy,
          timeFeeModel: (that.carInfo.timeFeeModel * 100).toString(),
        })
        .then((res) => {
          if (res.data.code == 0) {
            that.$message.success(
              `停车策略${that.parkModelId == 0 ? '设置' : '编辑'}成功`
            )
          } else {
            that.$message.error(
              `停车策略${that.parkModelId == 0 ? '设置' : '编辑'}失败`
            )
            that.pubilc_function1()
          }
          that.editDialogVisible2 = false
          that.getPowerStationList()
        })
    },
    // 弹窗关闭：停车策略
    btn_click2() {
      this.editDialogVisible2 = false
      // this.carInfo.feeModelType = 0;
      this.carInfo = {
        feeModelType: 0,
        billingPolicy: 0,
        timeFeeModel: 0,
        fixFee: 0,
        fixServiceFee: 0,
        parkModelId: 0,
      }
    },
    // 弹窗关闭：低速费率
    btn_click3() {
      this.celvDialog2 = false
      this.timeList1 = [
        {
          start: '00:00',
          end: '24:00',
        },
      ]
    },
    // 弹窗关闭：交直流费率
    btn_click1() {
      this.celvDialog1 = false
      this.timeList1 = [
        {
          start: '00:00',
          end: '24:00',
        },
      ]
    },
    // 弹窗弹起：停车策略弹窗
    stopCar(row) {
      const that = this
      that.editDialogVisible2 = true
      that.ids_all = row.id
      that.stationId = row.feeModelId
      that.parkModelId = row.parkModelId
      that.stationMode = row.stationMode
      that.$http
        .get(`feeModel/getFeeModelById/${row.parkModelId}`)
        .then((res) => {
          if (res.data.code !== 0) return
          that.carInfo = res.data.data
          // 停车费率
          that.carInfo.fixFee = that.carInfo.fixFee / 100
          // 免费时长不需要*100
          that.carInfo.fixServiceFee = that.carInfo.fixServiceFee
          // 封顶金额
          that.carInfo.timeFeeModel = that.carInfo.timeFeeModel / 100
          that.feeModelType = that.carInfo.feeModelType == 5 ? 0 : 1
        })
    },
    // 编辑：是否限定soc值实时更新
    switch_event(row) {
      this.$http
        .post(`station-info/updateStopSocById/${row.id}/${row.stopSOC}`)
        .then((res) => {
          if (res.data.code == 0) {
            this.getPowerStationList()
            this.$message.success('soc更新成功')
          }
        })
    },
    // 编辑：Soc值改变
    likai(row) {
      row.isstopsoc = 100
    },
    // 回显：图片弹窗
    beforeChange(file, fileList) {
      this.newfilelist = fileList
    },
    // 回显：图片弹窗
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    // 监听:table--pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryInfo.page = 1
      this.getPowerStationList()
    },
    // 监听:table--页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getPowerStationList()
    },
    // 删除：电站--对应id的电站事件
    async removeById(row) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该电站, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      if (confirmResult !== 'confirm')
        return this.$message.info('已经取消删除！')
      let url = row == 0 ? this.ids : row.id
      if (url == null || url == undefined || url == '')
        return this.$message.error('请选择你要删除的电站名称')
      this.$http
        .post(
          'station-info/delStationInfoById/' +
            Number(window.sessionStorage.getItem('adminId')) +
            '/' +
            url
        )
        .then((res) => {
          this.$message({
            message: res.data.code !== 0 ? '删除失败！' : '删除成功！',
            type: res.data.code !== 0 ? 'error' : 'success',
          })
          if (res.data.code == 0) return this.getPowerStationList()
        })
    },
    // 同意：上传场站图片(单)
    ok() {
      const formData = new FormData()
      this.fileList.forEach((item) => {
        formData.append('files', item.raw)
        formData.append('id', this.imgId)
      })
      this.$http
        .post('station-info/upLoadStationPicture', formData)
        .then((response) => {
          this.$message.success(response.data.msg)
          this.imgVisible = false
        })
        .catch((error) => {
          // 处理错误
          this.$message(error.data.msg)
        })
    },
    // 同意：上传场站轮播图（多）
    ok_succ() {
      const formData = new FormData()
      this.newfilelist.forEach((item) => {
        formData.append('files', item.raw)
        formData.append('id', this.imgId)
      })
      this.$http
        .post('station-info/upLoadStationPictures', formData)
        .then((response) => {
          this.$message.success(response.data.msg)
          this.imgVisible = false
        })
        .catch((error) => {
          // 处理错误
          this.$message(error.data.msg)
        })
    },
    //弹窗弹起 ：上传图片轮播、封面
    async img_station(e) {
      this.imgg = null
      this.imgges = null
      this.fileList = []
      this.newfilelist = []
      this.imgId = e.id
      this.imgVisible = true
      await this.$http
        .get('station-info/getStationInfoById/' + e.id)
        .then((res) => {
          e.s_c_anniu = res.data.code == 0 ? true : false
          this.imgg =
            res.data.code == 0 &&
            res.data.data.stationPicture !== null &&
            res.data.data.stationPicture !== undefined &&
            res.data.data.stationPicture !== ''
              ? this.tupian + res.data.data.stationPicture
              : null
          let abc =
            res.data.code == 0 &&
            res.data.data.stationPictures !== null &&
            res.data.data.stationPictures !== undefined &&
            res.data.data.stationPictures !== ''
              ? res.data.data.stationPictures.split(',')
              : ''
          console.log(abc, '1699')
          this.imgges = abc == '' ? null : abc
        })
    },
    // 弹窗弹起：充电策略弹窗
    showTariff(e) {
      const that = this
      that.ids_all = e.id
      that.feeModelId = e.feeModelId
      // 交直流
      that.celvDialog1 = e.stationMode == 0 ? true : false
      // 低速
      that.celvDialog2 = e.stationMode == 0 ? false : true
      if (e.stationMode == 0) {
        that.publicMethods()
      } else {
        console.log(e.feeModelId, '2006')
        if (e.feeModelId == 0) {
          that.pubilc_function2()
        } else {
          that.soetMethods()
        }
      }
    },
    // 弹窗弹起：充电策略--低速费率类型修改
    tariffChange2(e) {
      if (e == 4) {
        this.shuzu = [
          {
            name: '0',
            keys: '0',
            value2: '0',
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
          {
            name: '0',
            keys: '0',
            value2: 0,
          },
        ]
      }
      // console.log(e,'1315');
    },
    // 弹窗回显：交直流费率编辑
    publicMethods() {
      const that = this
      that.$http
        .get(`feeModel/getFeeModelById/${that.feeModelId}`)
        .then((res) => {
          if (res.data.code !== 0 || res.data.data == null)
            return that.pubilc_function1()
          that.MoneyInfo1 = res.data.data
          that.MoneyInfo1.fixFee = that.MoneyInfo1.fixFee / 10000
          that.MoneyInfo1.fixServiceFee = that.MoneyInfo1.fixServiceFee / 10000
          if (that.MoneyInfo1.feeModelType !== 0) {
            let abc = JSON.parse(that.MoneyInfo1.billingPolicy)
            that.MoneyInfo1.tip = abc.tip / 10000
            that.MoneyInfo1.tipService = abc.tipService / 10000
            that.MoneyInfo1.peak = abc.peak / 10000
            that.MoneyInfo1.peakService = abc.peakService / 10000
            that.MoneyInfo1.flat = abc.flat / 10000
            that.MoneyInfo1.flatService = abc.flatService / 10000
            that.MoneyInfo1.valley = abc.valley / 10000
            that.MoneyInfo1.valleyService = abc.valleyService / 10000
          }
          // 尖峰平谷时间段选择列表
          that.timeList1 =
            that.MoneyInfo1.feeModelType == 0
              ? []
              : JSON.parse(that.MoneyInfo1.timeJson)
          that.bill = that.timeList1
        })
    },
    // 低速
    pubilc_function2() {
      this.MoneyInfo2.fixFee = 0.0001
      this.MoneyInfo2.fixServiceFee =  0
      this.MoneyInfo2.feeModelType = 1
      this.billingPolicy2.tip = 0.0001
      this.billingPolicy2.tipService =  0
      this.billingPolicy2.peak = 0.0001
      this.billingPolicy2.peakService =  0
      this.billingPolicy2.flat = 0.0001
      this.billingPolicy2.flatService =  0
      this.billingPolicy2.valley = 0.0001
      this.billingPolicy2.valleyService =  0
      console.log(this.MoneyInfo2, '2103')
    },
    // 交直流
    pubilc_function1() {
      this.MoneyInfo1.fixFee = 0.0001
      this.MoneyInfo1.fixServiceFee = 0
      this.MoneyInfo1.feeModelType = 2
      this.MoneyInfo1.tip = 0.0001
      this.MoneyInfo1.tipService = 0
      this.MoneyInfo1.peak = 0.0001
      this.MoneyInfo1.peakService =  0
      this.MoneyInfo1.flat = 0.0001
      this.MoneyInfo1.flatService =  0
      this.MoneyInfo1.valley = 0.0001
      this.MoneyInfo1.valleyService =  0
    },
    // 弹窗回显：低速费率编辑
    soetMethods() {
      const that = this
      that.$http
        .get(`feeModel/getFeeModelById/${that.feeModelId}`)
        .then((ress) => {
          that.billingPolicy2 =
            ress.data.data.feeModelType == 2
              ? JSON.parse(ress.data.data.billingPolicy)
              : {
                  tipService: 0,
                  peak: 0.0001,
                  peakService: 0,
                  flat: 0.0001,
                  flatService: 0,
                  valley: 0.0001,
                  tip: 0.0001,
                  valleyService: 0,
                }
          console.log(that.billingPolicy2, ress.data.data.billingPolicy, '2121')
          if (ress.data.code !== 0 || ress.data.data == null)
            return that.pubilc_function2()
          that.MoneyInfo2 = ress.data.data
          if (that.MoneyInfo2.feeModelType == 2) {
            let ntr = JSON.parse(that.MoneyInfo2.billingPolicy)
            that.billingPolicy2 = {
              tip: ntr.tip / 1000,
              tipService: ntr.tipService / 1000,
              peak: ntr.peak / 1000,
              peakService: ntr.peakService / 1000,
              flat: ntr.flat / 1000,
              flatService: ntr.flatService / 1000,
              valley: ntr.valley / 1000,
              valleyService: ntr.valleyService / 1000,
            }
          }
          that.MoneyInfo2.fixFee =
            that.MoneyInfo2.feeModelType == 2 ||
            that.MoneyInfo2.feeModelType == 0
              ? that.MoneyInfo2.fixFee / 1000
              : that.MoneyInfo2.fixFee / 100
          that.MoneyInfo2.fixServiceFee =
            that.MoneyInfo2.feeModelType == 2 ||
            that.MoneyInfo2.feeModelType == 0
              ? that.MoneyInfo2.fixServiceFee / 1000
              : that.MoneyInfo2.fixServiceFee / 100
          console.log(
            that.MoneyInfo2.fixFee,
            that.MoneyInfo2.fixServiceFee,
            '2118'
          )
          that.activeIndex = that.MoneyInfo2.rateSchemeType
          that.objArray =
            that.MoneyInfo2.rateScheme == ''
              ? []
              : JSON.parse(that.MoneyInfo2.rateScheme)
          that.shuzu =
            that.MoneyInfo2.feeModelType == 4
              ? JSON.parse(that.MoneyInfo2.billingPolicy)
              : [
                  {
                    name: '0',
                    keys: '0',
                    value2: '0',
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                  {
                    name: '0',
                    keys: '0',
                    value2: 0,
                  },
                ]
          that.timeList1 =
            that.MoneyInfo2.feeModelType == 2
              ? JSON.parse(that.MoneyInfo2.timeJson)
              : []
        })
    },
    // 弹窗关闭：上传图片弹窗
    img_close() {
      this.imgVisible = false
      this.fileList = []
      this.newfilelist = []
      this.powerStationList.forEach((item) => {
        item.s_c_anniu = false
      })
    },
    // table表格
    getPowerStationList() {
      this.powerStationList = []
      if (
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
      ) {
        if (
          !this.queryInfo.name ||
          this.queryInfo.name == '' ||
          this.queryInfo.name == undefined
        ) {
          this.$delete(this.queryInfo, 'stationIds')
        }
      }
      this.$http
        .get('station-info/getAllStationInfo', {
          params: this.queryInfo,
        })
        .then((res) => {
          this.total = res.data.count
          if (res.data.code !== 0) return this.$message.error(res.data.msg)
          this.powerStationList = res.data.data
        })
    },
    // 弹窗添加、编辑电站
    async showPowerStation(e) {
      const that = this
      that.allid = e !== 0 ? e.id : null
      that.powerStationVisible = true
      that.initAMap()
      that.title = e == 0 ? '添加电站' : '编辑电站'
      if (e == 0) return
      await that.$http
        .get('station-info/getStationInfoById/' + e.id)
        .then((res) => {
          if (res.data.code !== 0) return that.$message.error(res.data.msg)
          that.parkid =
            e.parkType == 2
              ? res.data.data.parkModelThreeId
              : res.data.data.parkModelId
          console.log(that.parkid, '2577')
          e.b_j_anniu = true
          res.data.data.noticeStartTime == null
            ? ''
            : res.data.data.noticeStartTime
          res.data.data.noticeEndTime == null ? '' : res.data.data.noticeEndTime
          that.value1 = [
            that.stationInfo.noticeStartTime,
            that.stationInfo.noticeEndTime,
          ]
          that.stationInfo = res.data.data

          console.log(that.stationInfo.stationDisplay, '311')
          // that.stationInfo.feeModelDisplay =
          //   that.stationInfo.feeModelDisplay == 0 ? false : true
          // that.stationInfo.brokenNet =
          //   that.stationInfo.brokenNet == 0 ? true : false
          // that.stationInfo.stationDisplay == 0 ? false : true
        })
    },
    // 重置：搜索条件！
    chongzhi() {
      this.zhuangtai = '99'
      this.fenzhang = 2
      this.moshi = '2'
      this.$delete(this.queryInfo, 'orSas')
      this.$delete(this.queryInfo, 'stationState')
      this.queryInfo = {
        name: '',
        contacts: '',
        contactsTel: '',
        page: 1,
        limit: 8,
        stationMode: '0,1',
        roleId: window.sessionStorage.getItem('roleId'),
        stationIds: window.sessionStorage.getItem('stationIds'),
      }

      this.getPowerStationList()
    },
    // 列表行：多次勾选
    handleSelectionChange(value) {
      if (value.length < 0) return false
      this.ids = ''
      value.forEach((item) => {
        this.ids += item.id + ','
      })
      this.ids = this.ids.substring(0, this.ids.length - 1)
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-input.is-disabled .el-input__inner::-webkit-input-placeholder {
  text-align: center;
}

.range-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.el-col-24 {
  width: 8%;
}

.money1 {
  height: 20px;
  width: 40%;
  border: 1px solid #ccc;
  text-align: center;
}

.el-col-24 button {
  font-weight: 700;
  color: #fff;
}

.btnstyle {
  display: inline-block;
  text-align: center;
  border-bottom: none;
}

.el-checkbox-button:nth-child(6n + 1) {
  margin-right: -2px;
}

.el-checkbox-button:nth-child(6n + 2) {
  margin-right: -2px;
}

.el-checkbox-button:nth-child(6n + 3) {
  margin-right: -2px;
}

.el-checkbox-button:nth-child(6n + 4) {
  margin-right: -2px;
}

.el-checkbox-button:nth-child(6n + 5) {
  margin-right: -2px;
}

.el-checkbox-button:nth-child(n + 6) {
  margin-top: -2px;
}

#container {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 540px;
}

#myPageTop {
  position: absolute;
  top: 100px;
  right: 60px;
  z-index: 9999;
}
</style>
